export const changeLanguage = locale => {
    return {type: 'CHANGE_LANGUAGE', locale}
};